import request from '@/util/request';
export const carMonthRuleV2 = (params, options) =>
  request.get('/api/v4ward/car/monthDiscountRule/carMonthRuleV2/v2', Object.assign({}, options, {
    params
  }));



export const getSpaceList = () =>
  request.get('/api/v4ward/car/parkSpaceNode/treeChildrenCarParkNode/v2?id=0');

//月卡车快捷新增中根据车牌号查询是否是月卡车
export const isCarMonth = (params, options) =>
  request.get('/api/v4ward/monthcar/v1/quick/carMonth/query/v2', Object.assign({}, options, {
    params
  }));

//月卡车快速新增的保存
export const quickAdd = (params, options) =>
  request.post('/api/v4ward/monthcar/v1/quick/add/v2', params, options);



//月卡车快捷新增中根据车牌号查询是否是月卡车
export const getInfoByPlateNumber = (params, options) =>
  request.get('/api/v4ward/car/manage/getInfoByPlateNumber', Object.assign({}, options, {
    params
  }));